/**
 * Automations Entity Configuration
 * TODO: Implement in subtask 14.3
 */

import { useAutomations, useAutomation } from "../../../hooks/useApi";

const AutomationsConfig = {
  entity: "automations",
  entitySingular: "Automation",
  entityPlural: "Automations",

  hooks: {
    useEntities: useAutomations,
    useEntity: useAutomation,
  },

  routes: {
    list: "/automations",
    detail: "/automation/:id",
    new: "/new-automation",
    edit: "/automation/:id/edit",
  },

  statusOptions: [
    { value: "active", label: "Active", color: "green" },
    { value: "paused", label: "Paused", color: "yellow" },
    { value: "inactive", label: "Inactive", color: "gray" },
  ],

  filterFields: ["status", "type"],
  searchFields: ["name", "description", "type"],

  primaryField: "name",
  secondaryField: "description",

  defaultLayout: "cards",

  emptyState: {
    title: "No automations found",
    description: "Start by creating your first automation",
    actionText: "Create New Automation",
    actionRoute: "/new-automation",
  },

  features: {
    hasCategories: true,
    hasStatusBadges: true,
    hasProgressIndicators: false,
    hasQuickActions: true,
    supportsBulkActions: true,
  },
};

export default AutomationsConfig;
